/* global head, ga */
import openModal from '@PROJECT_ROOT/assets/shared/js/modalBox';

$(function() {
    // hrvatska odabrana po defaultu
    if ($('#jobApplicationForm_country').val() == '') {
        $('#jobApplicationForm_country').val('hr');
    }

    // dodani dokumenti
    var totalDocs = 1;
    $(document).on('click', '#addOtherDoc', function() {
        $('#otherDoc' + totalDocs++).removeClass('hidden');

        if (totalDocs == 10) {
            $(this).hide();
        }
    });

    //uploadaj dokument
    $(document).on('change', '.jobApplicationFile', (event) => {
        const filePath = event.currentTarget.value;
        const fileName = filePath.replace(/^.*[\\\/]/, '');
        const elementToChange = event.currentTarget.parentNode.querySelector('.js-filepath-label');
        elementToChange.textContent = fileName;
        event.currentTarget.blur();
    });

    // makni dokument
    $(document).on('click', '.removeOtherDoc', function() {
        $(this).closest('.otherDocContainer').addClass('hidden');
        $(this).closest('.otherDocContainer').find('.js-filepath-label')[0].textContent = 'Dodaj dokument';
        reset(document.getElementById(this.getAttribute('data-fileinputid')));
        $('#addOtherDoc').show();
        totalDocs--;
    });

    // čiščenje errora client side validacije na klik
    $(document).on('click', '.formInputHolder', function() {
        $(this).removeClass('rowError');
    });

    // grad i poštanski kod su required samo za Hrvatsku
    if ($('#jobApplicationForm_country').val() != 'hr') {
        $('#jobApplicationForm_town').closest('.formInputHolder').addClass('hidden');
        $('#jobApplicationForm_zipCode').closest('.formInputHolder').addClass('hidden');
    }

    $(document).on('change', '#jobApplicationForm_country', function() {
        if ($(this).val() == 'hr') {
            $('#jobApplicationForm_town').closest('.formInputHolder').removeClass('hidden');
            $('#jobApplicationForm_zipCode').closest('.formInputHolder').removeClass('hidden');
        } else {
            $('#jobApplicationForm_town').closest('.formInputHolder').addClass('hidden');
            $('#jobApplicationForm_zipCode').closest('.formInputHolder').addClass('hidden');
        }
    });

    // modal s uvjetima privola za natječaje za posao
    $(document).on('click', '#privateDataConsentExplanation', function(e) {
        e.preventDefault();
        const privateDataConsent = document.getElementById('privateDataConsentSource').innerHTML;
        openModal(privateDataConsent, { overlayCss: ['jobApplicationPrivacy']});
    });

    // skrivanje/prikazivanje greške koja se prikazuje ukoliko nije dana obavezna privola
    $(document).on('click', '#jobApplicationForm_usePrivateDataForThisJobVacancyConsent', function() {
        $(this).siblings('.errorMsg2').toggle();
    });

    // GA event i validacija
    $(document).on('submit', '#jobApplicationForm', function() {
        ga('send', 'event', 'About', 'Pošalji', $('#jobTitle').data('title'));

        let invalid = false;

        if ($('#jobApplicationForm_country').val() == 'hr') {
            const $town = $('#jobApplicationForm_town');
            if ($town.val() == '') {
                $town.closest('.formInputHolder').addClass('rowError');
                invalid = true;
            }

            const $zipCode = $('#jobApplicationForm_zipCode');
            if ($zipCode.val() == '') {
                $zipCode.closest('.formInputHolder').addClass('rowError');
                invalid = true;
            }
        }

        if (invalid) {
            $('#jobApplicationForm_town').focus();
            return false;
        }
    });
});

/**
 * Workaround za reset file input polja u IE9
 *
 * https://stackoverflow.com/questions/6987452/clearing-file-input-box-in-internet-explorer/14587296#14587296
 */
function reset(e) {
    $(e).wrap('<form>').closest('form').get(0).reset();
    $(e).unwrap();
}
